import { render, staticRenderFns } from "./beforeGameOpenModal.vue?vue&type=template&id=01950fc6"
import script from "./beforeGameOpenModal.vue?vue&type=script&lang=js"
export * from "./beforeGameOpenModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports